import React from 'react';
import { Gradient } from '../Gradient';

const Star = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M18.5681 8.95524C19.3573 8.38143 18.9514 7.13301 17.9757 7.13301H14.1427C13.2634 7.13301 12.4856 6.56279 12.2212 5.72421L10.9533 1.7044C10.6571 0.765199 9.32797 0.765201 9.03175 1.7044L7.76389 5.72421C7.4994 6.56279 6.72164 7.13301 5.84234 7.13301H2.00936C1.03363 7.13301 0.627737 8.38143 1.4169 8.95524L4.83064 11.4374C5.56839 11.9739 5.85374 12.939 5.52628 13.7903L4.04536 17.6406C3.68506 18.5774 4.7665 19.4074 5.57818 18.817L8.80742 16.4685C9.51394 15.9546 10.4711 15.9546 11.1776 16.4685L14.4069 18.817C15.2185 19.4074 16.3 18.5774 15.9397 17.6406L14.4588 13.7904C14.1313 12.939 14.4167 11.9739 15.1544 11.4374L18.5681 8.95524Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default Star;